import { AfterContentChecked, Directive, ElementRef, HostListener, Input } from '@angular/core';



export class AutosizeDirective implements AfterContentChecked {
   init_height: number = 0;
  
  onInput(textArea: HTMLTextAreaElement): void {
    this.adjust();
  }
  constructor(public element: ElementRef) {
  }
  ngAfterContentChecked(): void {
    this.adjust();
  }
  adjust(): void {
    this.element.nativeElement.style.overflow = 'hidden';
    this.element.nativeElement.style.height = this.init_height ? this.init_height + 'px' : 'auto';
    this.element.nativeElement.style.height = this.element.nativeElement.scrollHeight + 'px';
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: 'textarea[autosize]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'init_height': [{ type: Input },],
'onInput': [{ type: HostListener, args: ['input', ['$event.target'], ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
